
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import { CustomAppEventListener }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';


export const getApiData = (obj, option) => {
    let dataArr = [];
    let showData = [];

    if (obj && obj.hasOwnProperty('Levels')) {
        dataArr = [...obj.Levels];
        if (option !== 'contents') {
            for (let i = 0; i < dataArr.length; i++) {
                if (dataArr[i].Levels) {
                    let data = [];
                    if (dataArr[i].hasOwnProperty('Levels')) {
                        data = [...dataArr[i].Levels];
                        if ((+dataArr[i].HideLevel !== 1) && (+dataArr[i].HideLevel !== 2)
                            && option == CustomTypes.API_MODELS) {
                            showData.push(dataArr[i]);
                            dataArr[i].showmodel = true;
                        }
                        for (let j = 0; j < data.length; j++) {
                            if (option === CustomTypes.API_TAGS) {
                                let tags = [];
                                tags = [...data[j].Levels];
                                if (+data[j].HideLevel !== 1 && +data[j].HideLevel !== 2) {
                                    tags.push({ ...data[j], Levels: [] });
                                }
                                for (let k = 0; k < tags.length; k++) {
                                    if ((+tags[k].HideLevel !== 1) && (+tags[k].HideLevel !== 2)) {
                                        showData.push(tags[k]);
                                    }
                                }
                            } else if ((option === "derivates") || (option === CustomTypes.API_MODELS)) {
                                if ((+data[j].HideLevel !== 1) && (+data[j].HideLevel !== 2)) {
                                    showData.push(data[j]);
                                }
                            }
                        }
                    }
                }
            }
        } else {
            return dataArr;
        }
    }
    return showData;
}

export const getSelectedTags = (data, props) => {
    data = data || "";
    if ((data !== undefined) && (data !== "") && (data.length >= 1)) {
        let selectedTags = [];
        data.map((item) => { selectedTags.push(item[props]); });
        return selectedTags.join(';');
    }
    return data;
}

class ApiTags extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    setUlConstraints = (uploadConfig) => {
        if (DataUtil.isFrancetv()) {
            uploadConfig.forEach(tab => {
                tab.data.forEach(item => {
                    if (item.name && this.props.customUlConstraints[item.name]) {
                        let constraints = this.props.customUlConstraints[item.name];
                        if (item.data && item.data.length) {
                            let newData = item.data.filter(entry => constraints.every(el => el != entry.ID));
                            item.data = newData;
                        }
                    }
                })
            })
        }
        return uploadConfig;
    }

    setDataFormSettings = (element) => {
        if (element) {
            let formTabs = CustomAppEventListener("getFormTabs", element.clip);
            let uploadConfig = [];
            let expertSearchConfig = [];
            let tempConfig = [{
                "lgMsId": "metadata.tab.masterdata",
                "name": "masterdata", data: []
            }];

            // Upload
            uploadConfig = CustomForm.initFormDataForApp({
                formName: CustomTypes.APP_FORM_UPLOAD, formData: element.clip, formTabs,
                user: this.props.user, users: this.props.users
            });
            if (uploadConfig) {
                uploadConfig = CustomForm.addFieldsToConfigDataForApp(uploadConfig, this.props.customFlexAppConfig, "workflows");
                uploadConfig = this.setUlConstraints(uploadConfig);
                this.props.addApiUploadConfig(uploadConfig);
            }
            //Search
            expertSearchConfig = CustomForm.initFormDataForApp({
                formName: CustomTypes.APP_FORM_SEARCH, formData: element.clip, formTabs,
                user: this.props.user, users: this.props.users, lg: this.props.lg
            });
            if (expertSearchConfig) this.props.addApiExpertSearchConfig(expertSearchConfig);

            //Masterupload
            tempConfig = CustomForm.checkAndUpdateConfigForApp({
                uiConfig: this.props.uiConfig, tempConfig,
                flexConfig: this.props.customFlexAppConfig,
                users: this.props.users, lg: this.props.lg
            });
            if (tempConfig) this.props.addTempConfig(tempConfig);

            //MetaData
            if (!this.props.customConfigClipInfoForApp) {
                this.props.getCustomConfigClipInfoForApp(CustomAppEventListener("convertMetadata", element.clip));
            }
        }
    }

    componentDidMount() {
        try {
            this.props.loadUsers();
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then(module => {
                let element = DataUtil.isFrancetv() ? this.props.metadataconfig : module;
                this.setDataFormSettings(element);
            });
            if (DataUtil.isFrancetv()) this.props.getFtvmetaUlConstraints();

        } catch (error) {
            console.log("ERROR: appConfig!");
        }

        if (DataUtil.isPMDB()) {
            window.flow.fileGet(CustomTypes.TAGS_FILE)
                .then(res => JSON.parse(res.content))
                .then(obj => { this.props.addApiTags(obj); })
                .catch(e => { console.log(`CustomDataApi could not load "${CustomTypes.TAGS_FILE}"`, e + ''); });

            window.flow.fileGet(CustomTypes.MODELS_FILE)
                .then(res => JSON.parse(res.content))
                .then(obj => { this.props.addApiModels(obj); })
                .catch(e => { console.log(`CustomDataApi could not load "${CustomTypes.MODELS_FILE}"`, e + ''); });

            window.flow.fileGet(CustomTypes.CONSUMPTION_FILE)
                .then(res => JSON.parse(res.content))
                .then(obj => { this.props.addApiConsumption(obj); })
                .catch(e => { console.log(`CustomDataApi could not load "${CustomTypes.CONSUMPTION_FILE}"`, e + ''); });
        }
    }

    updateSearchSettings = (element) => {
        if (element) {
            if (element.clip) {
                let configClipInfo = CustomAppEventListener("convertMetadata", element.clip);
                this.props.getCustomConfigClipInfoForApp(configClipInfo);
                if (this.props.sort && configClipInfo) {
                    let sortOption = CustomAppEventListener("getSortOption", this.props.sort.orderBy, configClipInfo);
                    if (sortOption) {
                        this.props.searchSetSortDefault({ orderBy: sortOption, order: 'DESC' });
                        this.props.searchSetSortOrderDefault(sortOption);
                        this.props.setCustomCurrentSortOption(`${sortOption}|DESC`);
                    }
                }
            }
            this.props.getCustomFlexAppConfig({ metadata: element.clip, mediafileItems: element.mediafile });
        }
    }

    componentDidUpdate(prevProps) {
        if ((JSON.stringify(prevProps.metadataconfig.clip) !== JSON.stringify(this.props.metadataconfig.clip))
            || prevProps.users !== this.props.users) {
            this.setDataFormSettings(this.props.metadataconfig);
            this.updateSearchSettings(this.props.metadataconfig);
        }

        if (prevProps.customUlContraints != this.props.customUlContraints && DataUtil.isFrancetv()) {
            this.setDataFormSettings(this.props.metadataconfig);
        }
    }

    render() {
        return (<div></div>)
    }
}

const mapStateToProps = (state) => ({
    users: state.admin.users,
    user: state.auth.user,
    customConfigClipInfoForApp: state.customData.customConfigClipInfoForApp,
    uiConfig: state.customData.customUiConfigForApp,
    customFlexAppConfig: state.customData.customFlexAppConfig,
    customUlConstraints: state.customData.customUlConstraints,
    sort: state.search.sort,
    metadataconfig: state.metadata.config,
    lg: state.ui.language,
});
const mapDispatchToProps = (dispatch) => {
    return {
        addApiTags: (apiTags) => dispatch(actions.addApiTags(apiTags)),
        addApiModels: (apiModels) => dispatch(actions.addApiModels(apiModels)),
        addApiConsumption: (apiConsumption) => dispatch(actions.addApiConsumption(apiConsumption)),
        addApiAppsConfig: (appsConfig) => dispatch(actions.addApiAppsConfig(appsConfig)),
        addApiUploadConfig: (uploadConfig) => dispatch(actions.addApiUploadConfig(uploadConfig)),
        addApiExpertSearchConfig: (expertSearchConfig) => dispatch(actions.addApiExpertSearchConfig(expertSearchConfig)),
        addTempConfig: (tempConfig) => dispatch(actions.addTempConfig(tempConfig)),
        loadUsers: () => dispatch(actions.adminGetUsers()),
        getCustomConfigClipInfoForApp: (data) => dispatch(actions.getCustomConfigClipInfoForApp(data)),
        getCustomAppData: (data, type) => dispatch(actions.getCustomAppData(data, type)),
        getCustomFlexAppConfig: (data) => dispatch(actions.getCustomFlexAppConfig(data)),
        searchSetSortDefault: (data) => dispatch(actions.searchSetSortDefault(data)),
        searchSetSortOrderDefault: (data) => dispatch(actions.searchSetSortOrderDefault(data)),
        setCustomCurrentSortOption: (option) => dispatch(actions.setCustomCurrentSortOption(option)),
        getFtvmetaUlConstraints: () => dispatch(actions.getFtvmetaUlConstraints())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiTags);










